<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="datastory-block">
    <div class="has-side-bars">
      <div class="datastory-header">
        <div class="datastory-title-container">
          <h2 class="datastory-title">{{ $t('datastory_title') }}</h2>
          <h3 class="datastory-desc">{{ $t('datastory_desc_prev') }}</h3>
        </div>
        <a class="show-more" href="/map-datastories">{{ $t('show_more') }}</a>
      </div>
      <div v-if="dataStoriesCards" class="datastory-body">
        <div v-if="dataStoriesCards.code === 500" class="cms-error">{{ $t('not_cms') }}</div>
        <div v-else-if="!isMobile" class="datastory-cards">
          <DataStoryCard
            v-for="(card, i) in dataStoriesCards"
            :key="i"
            :card="card"
            type="normal"
          />
        </div>
        <div v-else-if="isMobile" class="datastories-wrap">
          <carousel :per-page="1" :navigate-to="currentPage" @page-change="n => (currentPage = n)">
            <slide v-for="(dtst, i) in dataStoriesCards" :key="i" class="slide">
              <DataStoryCard :card="dtst" type="normal" />
            </slide>
          </carousel>
        </div>
      </div>
      <div v-else class="loader-wrap">
        <Loader :text="$t('loading')" />
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import DataStoryCard from './DataStoryCard.vue'
import Loader from '../Loader.vue'
import { getCMSDatastories } from '@/services/graphql'
export default {
  components: { Carousel, Slide, DataStoryCard, Loader },
  props: {},
  data() {
    return {
      currentPage: 0,
      
    }
  },
  asyncComputed: {
    dataStoriesCards() {

      return getCMSDatastories(this.$store.state.i18n.lang).then((resp) =>
        {
          if(resp.code === 500) return resp
          else {
            let dataStoriesData =  resp.sort((a, b) => {
              return a.score - b.score
            })
            return dataStoriesData.slice(0, 4)
          }
        }
      )
    },
  },
  watch: {},
  methods: {},
}
</script>

<style lang="stylus" scoped>
.datastory-block
  background-color: $very-light-grey
  padding-bottom: vw(90px)
  padding-top: vw(90px)

  .mobile &
    padding-bottom: vw(50px)
    padding-top: vw(50px)

  .cms-error
    m-font-size(20, 26)
    color: black
    display: flex
    justify-content: center
    margin-top: vw(20px)
    padding-bottom: vw(10px)

.datastory-header
  display: flex
  gap: vw(50px)
  margin-bottom: vw(40px)

.datastory-title-container
  flex: 1 1 0%

.datastory-title
  m-font-size(32, 44)
  font-weight: 600
  margin-block-start: 0
  margin-block-end: vw(10px)
  color: $base-font-color

.datastory-desc
  m-font-size(18, 26)
  color: $grey
  margin-block-start: 0
  margin-block-end: 0

.show-more
  m-font-size(14, 20)
  align-self: flex-end
  border: 1px solid $grey-accessibility
  border-radius: 3px
  color: $grey-dark
  padding: vw(10px) vw(12px)

  .mobile &
    min-width: vw(80px)

  &:hover
    border-color: $corporate_color
    color: $corporate_color

.datastory-cards
  $gap = vw(20px)
  display: flex
  flex-wrap: wrap
  gap: $gap

  .datastory-card
    $percentage = percentage((1 / 4))
    $gap-percentage = 1 + 1 / 3
    $width = "calc(%s - (%s / %s))" % ($percentage $gap $gap-percentage)
    flex: 0 0 $width

  .VueCarousel
    width: 100%

    .slide
      display: flex
      gap: vw(10px)
      overflow: hidden

.loader-wrap
  height: 110px
  position: relative
  width: 100%

.datastories-wrap
  >>> .VueCarousel-dot-container
    display: flex
    gap: 20px

  >>> .VueCarousel-dot
    border: 1px solid $grey-dark
    padding: 0px !important

  >>> .VueCarousel-pagination
    display: flex
</style>